import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProviderService } from '../../../service/provider.service';

@Component({
  selector: 'app-contract-evaluate',
  templateUrl: './contract-evaluate.component.html',
  styleUrls: ['./contract-evaluate.component.less']
})
export class ContractEvaluateComponent implements OnInit {

  @Input() code: any; // 0 评价 1 查看评价详情
  @Input() pno: any;
  @Input() cid: any;
  validateForm: FormGroup;
  constructor(
    private fb: FormBuilder,
    private providerService: ProviderService,
  ) { }

  ngOnInit(): void {
    this.validateForm = this.fb.group({
      responseTimeEvaluation: ['3', [Validators.required]], // 合同名称
      serviceEfficiencyQualityEvaluation: ['3', [Validators.required]], // 合同编号
      servicePrice: ['3', [Validators.required]], //
      otherEvaluation: ['3', [Validators.required]], //
    });
    if (this.code === 1){
      this.providerService.getContract(this.cid).subscribe((data: any) => {
        if ( !this.isEmpty(data) ){
          this.setValidateForm(data);
          this.validateForm.disable();
        }
      });
    }
  }
  getForm(){
    return this.validateForm;
  }
  setValidateForm(contract: any){
    this.validateForm.get('responseTimeEvaluation').setValue(
      !this.isEmpty(contract.responseTimeEvaluation) ? contract.responseTimeEvaluation : null);
    this.validateForm.get('serviceEfficiencyQualityEvaluation').setValue(
      !this.isEmpty(contract.serviceEfficiencyQualityEvaluation) ? contract.serviceEfficiencyQualityEvaluation : null);
    this.validateForm.get('servicePrice').setValue(
      !this.isEmpty(contract.servicePrice) ? contract.servicePrice : null);
    this.validateForm.get('otherEvaluation').setValue(
      !this.isEmpty(contract.otherEvaluation) ? contract.otherEvaluation : null);
  }
  isEmpty(obj: any) {
    if (typeof obj === 'undefined' || obj === null || obj === '') {
      return true;
    } else {
      return false;
    }
  }
}
